import { useEffect } from '@wordpress/element';
const ROW_SELECTOR = 'tr:not([role]), [role="row"]';
const TREE_GRID_SELECTOR = '[role="treegrid"]';
function getAriaOwners(element) {
  if (!element.id) {
    return [];
  }
  const escapedId = element.id.replaceAll('\\', '\\\\').replaceAll('"', '\\"');
  return Array.from(element.ownerDocument.querySelectorAll(`[aria-owns~="${escapedId}"]`));
}
function isContainedInOrOwnedBy(element, selector, visited = new Set()) {
  if (visited.has(element)) {
    return false;
  }
  visited.add(element);
  if (element.parentElement?.closest(selector)) {
    return true;
  }
  const hasValidOwner = getAriaOwners(element).some(owner => owner.matches(selector) || isContainedInOrOwnedBy(owner, selector, visited));
  if (hasValidOwner) {
    return true;
  }
  return element.parentElement ? isContainedInOrOwnedBy(element.parentElement, selector, visited) : false;
}
function isOwnedByRowInTreeGrid(element, visited = new Set()) {
  if (visited.has(element)) {
    return false;
  }
  visited.add(element);
  const hasValidOwner = getAriaOwners(element).some(owner => {
    const row = owner.matches(ROW_SELECTOR) ? owner : owner.closest(ROW_SELECTOR);
    return row ? isContainedInOrOwnedBy(row, TREE_GRID_SELECTOR) : isOwnedByRowInTreeGrid(owner, visited);
  });
  if (hasValidOwner) {
    return true;
  }
  return element.parentElement ? isOwnedByRowInTreeGrid(element.parentElement, visited) : false;
}
export function useValidateTreeGridStructure(componentName, elementRef) {
  useEffect(() => {
    const element = elementRef.current;
    if (!element) {
      return;
    }
    const row = element.parentElement?.closest(ROW_SELECTOR);
    const hasValidStructure = componentName === 'TreeGridRow' ? isContainedInOrOwnedBy(element, TREE_GRID_SELECTOR) : row && isContainedInOrOwnedBy(row, TREE_GRID_SELECTOR) || isOwnedByRowInTreeGrid(element);
    if (!hasValidStructure) {
      throw new Error(componentName === 'TreeGridRow' ? 'TreeGridRow must be rendered inside an element with role="treegrid".' : 'TreeGridCell must be rendered as a cell in a row that belongs to an element with role="treegrid".');
    }
  }, [componentName, elementRef]);
}